/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "helpers/moment";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";
import SelectDates from "../../selectDates";
import { useUserContext } from "contexts/userContext";
import { AIRLINES } from "constants/appConstants";

/* Styles */
import styles from "./styles.js"
import UCToggle from "../../uctoggle";


const SafetyFilters = ({gridOptions, setGridOptions}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const d = new Date();
  const timezoneOffset = d.getTimezoneOffset();
  const intl = useIntl();
  const userContext = useUserContext();

  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;
  const providerIsNotChoice = providerCode !== AIRLINES.CHOICE

  const applyDates = (type) => {
    let range = {};
    switch (type) {
      case "month":
        range = {
          startDate: moment().startOf('month').format("YYYY-MM-DD"),
          endDate: moment().endOf('month').format("YYYY-MM-DD"),
        }
        break;
      case "week":
        range = {
          startDate: moment().startOf('week').format("YYYY-MM-DD"),
          endDate: moment().endOf('week').format("YYYY-MM-DD")
        }
        break;
      case "yesterday":
        range = {
          startDate: moment().add(-1, 'days').format("YYYY-MM-DD"),
          endDate: moment().add(-1, 'days').format("YYYY-MM-DD")
        }
        break;
      case "today":
        const today = moment();
        range = {
          startDate: today.format("YYYY-MM-DD"),
          endDate: today.format("YYYY-MM-DD")
        }
        break;
    }
    setGridOptions({
      ...gridOptions,
      ...range,
      type: type,
      page: 1
    })
  }

  const convertCurrentTimezoneOffset = (timezoneOffset) => {

    if (timezoneOffset === 0 ) {
      return timezoneOffset
    }
    return timezoneOffset * -1;
  }

  const showInCurrentTimezone = (e) => {

    setGridOptions({
      ...gridOptions,
      timezoneOffset: e.target.checked ? convertCurrentTimezoneOffset(timezoneOffset) : null,
    })
  }

  return (
    <div className={classes.filters}>
      <div className={classes.filterContainer}>
      <div className={classes.filterButtons}>
        <div className={classes.filterGroups}>
          <UCButton
            onClick={() => applyDates('month')}
            type="default"
            className={`${classes.filter} ${classes.thisMonth} ${gridOptions?.type === "month" ? classes.active : ""}`}
            text={<FormattedMessage id="safety.filters.thisMonth" />}
            tabIndex={0}
          />
          <UCButton
            onClick={() => applyDates('week')}
            type="default"
            className={`${classes.filter} ${classes.thisWeek} ${gridOptions?.type === "week" ? classes.active : ""}`}
            text={<FormattedMessage id="safety.filters.thisWeek" />}
            tabIndex={0}
          />
        </div>
        <div className={classes.filterGroups}>
          <UCButton
            onClick={() => applyDates('yesterday')}
            type="default"
            className={`${classes.filter} ${classes.yesterday} ${gridOptions?.type === "yesterday" ? classes.active : ""}`}
            text={<FormattedMessage id="safety.filters.yesterday" />}
            tabIndex={0}
          />
          <UCButton
            onClick={() => applyDates('today')}
            type="default"
            className={`${classes.filter} ${classes.today} ${gridOptions?.type === "today" ? classes.active : ""}`}
            text={<FormattedMessage id="safety.filters.today" />}
            tabIndex={0}
          />
        </div>
      </div>
      <div>
        <SelectDates gridOptions={gridOptions} setGridOptions={setGridOptions}/>
      </div>
      </div>

      {providerIsNotChoice && (
         <div className={classes.buttonContainer}>
          <UCToggle
            label={intl.formatMessage({id: "safety.toggle.text"})}
            className={classes.toggleStyle}
            icons={null}
            onChange={showInCurrentTimezone}
            defaultChecked={false}
            disabled={!timezoneOffset}
            ariaLabel={intl.formatMessage({id: "safety.toggle.text"})}
          />
        </div>
      )}
    </div>
  )
}

export default SafetyFilters;
